// Bilingual translations
export const translations = {
  de: {
    nav: {
      features: "Funktionen",
      privacy: "Datenschutz",
      pricing: "Preise",
      login: "Anmelden",
      dashboard: "Dashboard",
      patients: "Patienten",
      newSession: "Neue Sitzung",
      settings: "Einstellungen",
      logout: "Abmelden",
    },
    landing: {
      eyebrow: "DSGVO-konform · HIPAA-Ready",
      heroTitle: "Sprachnotizen.",
      heroTitle2: "SOAP-Berichte. In Sekunden.",
      heroSub: "PhysioSOAP wandelt Ihre gesprochenen oder geschriebenen Behandlungsnotizen automatisch in strukturierte medizinische SOAP-Berichte um — sicher, präzise und exportbereit.",
      ctaPrimary: "Kostenlos starten",
      ctaSecondary: "Mehr erfahren",
      trust1: "EU-gehosteter Datenschutz",
      trust2: "Verschlüsselte Patientendaten",
      trust3: "Whisper · Claude Sonnet 4.5",
      featuresTitle: "Mehr Zeit für Patient:innen, weniger für Dokumentation.",
      f1Title: "Patientendatenbank",
      f1Desc: "Eine zentrale, verschlüsselte Datenbank für alle Patient:innen, Diagnosen und Behandlungsverläufe.",
      f2Title: "Sprache zu SOAP",
      f2Desc: "Diktieren Sie Ihre Notizen — die KI strukturiert sie in Subjektiv, Objektiv, Beurteilung und Plan.",
      f3Title: "PDF-Export",
      f3Desc: "Professionelle SOAP-Berichte als PDF — direkt in der Patientenakte.",
      f4Title: "DSGVO & HIPAA",
      f4Desc: "Datenschutz auf höchstem Niveau. Datenresidenz in der EU. Ende-zu-Ende verschlüsselt.",
      privacyTitle: "Datenschutz ist kein Feature — es ist die Grundlage.",
      privacyDesc: "Wir speichern Patientendaten ausschließlich in EU-Rechenzentren. Kein Training auf Ihren Daten. Volle Kontrolle, jederzeit löschbar.",
      footer: "© 2026 PhysioSOAP. Made for therapists, with care.",
    },
    auth: {
      title: "Willkommen zurück",
      sub: "Melden Sie sich mit Ihrem Google-Konto an, um fortzufahren.",
      google: "Mit Google anmelden",
      hint: "Ihre Daten bleiben Ihre Daten. EU-gehostet, DSGVO-konform.",
    },
    dash: {
      welcome: "Willkommen,",
      kpiPatients: "Patienten",
      kpiSessions: "Sitzungen gesamt",
      kpiWeek: "Sitzungen (7 Tage)",
      recentSessions: "Letzte Sitzungen",
      noSessions: "Noch keine Sitzungen. Starten Sie mit einer neuen Sitzung.",
      quickActions: "Schnellaktionen",
      addPatient: "Patient hinzufügen",
      newSession: "Neue Sitzung starten",
    },
    patients: {
      title: "Patient:innen",
      add: "Patient hinzufügen",
      search: "Suchen (Name, Diagnose, Sitzungs-Inhalt)...",
      empty: "Noch keine Patient:innen angelegt.",
      first: "Vorname",
      last: "Nachname",
      dob: "Geburtsdatum",
      gender: "Geschlecht",
      phone: "Telefon",
      email: "E-Mail",
      diagnosis: "Diagnose",
      notes: "Notizen",
      save: "Speichern",
      cancel: "Abbrechen",
      edit: "Bearbeiten",
      delete: "Löschen",
      sessions: "Behandlungssitzungen",
      newSession: "Neue Sitzung",
      backToList: "Zurück zur Liste",
      created: "Angelegt",
      confirmDelete: "Patient wirklich löschen? Alle Sitzungen werden ebenfalls entfernt.",
      dateFrom: "Von",
      dateTo: "Bis",
      clearFilters: "Filter zurücksetzen",
      sessionMatches: "passende Sitzung(en)",
      lastSession: "Letzte Sitzung",
      noSessions: "Keine Sitzungen",
      matchingSessions: "Passende Sitzungen",
      filtersActive: "Filter aktiv",
    },
    session: {
      title: "Neue Behandlungssitzung",
      selectPatient: "Patient:in auswählen",
      voiceTab: "Sprache",
      textTab: "Text",
      recordStart: "Aufnahme starten",
      recordStop: "Aufnahme stoppen",
      recording: "Nimmt auf...",
      transcribing: "Transkribiere...",
      generating: "Generiere SOAP-Bericht...",
      placeholderText: "Geben Sie hier Ihre Behandlungsnotizen ein. Die KI erstellt daraus einen strukturierten SOAP-Bericht.",
      generate: "SOAP-Bericht erzeugen",
      save: "Sitzung speichern",
      saving: "Speichere...",
      pdf: "Als PDF exportieren",
      sectionS: "S — Subjektiv",
      sectionO: "O — Objektiv",
      sectionA: "A — Beurteilung",
      sectionP: "P — Plan",
      regenerate: "Neu generieren",
      noPatient: "Bitte wählen Sie zuerst eine/n Patient:in.",
      noNotes: "Bitte geben Sie zuerst Notizen ein.",
      sessionsList: "Sitzungen",
      backToSession: "Zurück",
      edit: "Bearbeiten",
      saveChanges: "Änderungen speichern",
      cancelEdit: "Verwerfen",
      saved: "Gespeichert",
      billing: "Abrechnungs-Codes",
      billingTitle: "Abrechnungs-Assistent",
      billingDesc: "KI-Vorschläge für Heilmittel-Positionsnummern basierend auf dem SOAP-Bericht.",
      billingSuggest: "Vorschläge generieren",
      billingLoading: "Analysiere SOAP-Bericht...",
      billingEmpty: "Klicken Sie auf 'Vorschläge generieren', um passende Positionsnummern zu sehen.",
      billingDisclaimer: "Hinweis: KI-Vorschläge ersetzen nicht die ärztliche Verordnung. Prüfen Sie die Codes vor der Abrechnung.",
      copyCode: "Kopieren",
      copied: "Kopiert!",
    },
    settings: {
      title: "Einstellungen",
      account: "Konto",
      language: "Sprache",
      privacy: "Datenschutz",
      privacyDesc: "PhysioSOAP speichert Ihre Daten DSGVO-konform in EU-Rechenzentren. Patientendaten werden niemals zum Training von KI-Modellen verwendet. Sie können Ihre Daten jederzeit exportieren oder löschen.",
      retention: "Datenaufbewahrung",
      retentionDesc: "Patientendaten und Sitzungen werden so lange aufbewahrt, wie es Ihre Gesetzgebung vorsieht (typ. 10 Jahre für medizinische Aufzeichnungen).",
      delete: "Konto-Daten löschen",
      logout: "Abmelden",
      practice: "Praxisdaten",
      practiceDesc: "Diese Angaben erscheinen in der Fußzeile jedes generierten PDF-Berichts.",
      practiceName: "Praxisname",
      practiceAddress: "Adresse",
      practicePhone: "Telefon",
      practiceEmail: "E-Mail",
      practiceSave: "Praxisdaten speichern",
      practiceSaved: "Gespeichert!",
      practiceNamePh: "z.B. Physiotherapie Dr. Müller",
      practiceAddressPh: "Musterstraße 12, 10115 Berlin",
      practicePhonePh: "+49 30 1234567",
      practiceEmailPh: "praxis@example.de",
      logo: "Praxislogo",
      logoDesc: "Ihr Logo erscheint im Kopfbereich jedes PDF-Berichts. PNG, JPEG oder WebP, max. 2 MB.",
      logoUpload: "Logo hochladen",
      logoReplace: "Logo ersetzen",
      logoRemove: "Entfernen",
      logoUploading: "Lade hoch...",
      logoNone: "Kein Logo — PhysioSOAP-Standard-Logo wird verwendet.",
    },
    common: {
      loading: "Lädt...",
      error: "Fehler",
      yes: "Ja",
      no: "Nein",
    },
  },
  en: {
    nav: {
      features: "Features",
      privacy: "Privacy",
      pricing: "Pricing",
      login: "Sign in",
      dashboard: "Dashboard",
      patients: "Patients",
      newSession: "New Session",
      settings: "Settings",
      logout: "Log out",
    },
    landing: {
      eyebrow: "GDPR-compliant · HIPAA-Ready",
      heroTitle: "Voice notes.",
      heroTitle2: "SOAP reports. In seconds.",
      heroSub: "PhysioSOAP turns your spoken or written treatment notes into structured medical SOAP reports — secure, precise, and ready to export.",
      ctaPrimary: "Get started free",
      ctaSecondary: "Learn more",
      trust1: "EU-hosted privacy",
      trust2: "Encrypted patient data",
      trust3: "Whisper · Claude Sonnet 4.5",
      featuresTitle: "More time for patients, less for documentation.",
      f1Title: "Patient database",
      f1Desc: "A central, encrypted database for all your patients, diagnoses and treatment history.",
      f2Title: "Voice to SOAP",
      f2Desc: "Dictate your notes — AI structures them into Subjective, Objective, Assessment and Plan.",
      f3Title: "PDF export",
      f3Desc: "Professional SOAP reports exported to PDF — straight from the patient record.",
      f4Title: "GDPR & HIPAA",
      f4Desc: "Privacy at the highest level. Data residency in the EU. End-to-end encrypted.",
      privacyTitle: "Privacy isn't a feature — it's the foundation.",
      privacyDesc: "We store patient data only in EU data centers. No training on your data. Full control, deletable any time.",
      footer: "© 2026 PhysioSOAP. Made for therapists, with care.",
    },
    auth: {
      title: "Welcome back",
      sub: "Sign in with your Google account to continue.",
      google: "Sign in with Google",
      hint: "Your data stays your data. EU-hosted, GDPR-compliant.",
    },
    dash: {
      welcome: "Welcome,",
      kpiPatients: "Patients",
      kpiSessions: "Total sessions",
      kpiWeek: "Sessions (7 days)",
      recentSessions: "Recent sessions",
      noSessions: "No sessions yet. Start with a new session.",
      quickActions: "Quick actions",
      addPatient: "Add patient",
      newSession: "Start new session",
    },
    patients: {
      title: "Patients",
      add: "Add patient",
      search: "Search (name, diagnosis, session content)...",
      empty: "No patients yet.",
      first: "First name",
      last: "Last name",
      dob: "Date of birth",
      gender: "Gender",
      phone: "Phone",
      email: "Email",
      diagnosis: "Diagnosis",
      notes: "Notes",
      save: "Save",
      cancel: "Cancel",
      edit: "Edit",
      delete: "Delete",
      sessions: "Treatment sessions",
      newSession: "New session",
      backToList: "Back to list",
      created: "Created",
      confirmDelete: "Delete patient? All sessions will be removed.",
      dateFrom: "From",
      dateTo: "To",
      clearFilters: "Reset filters",
      sessionMatches: "matching session(s)",
      lastSession: "Last session",
      noSessions: "No sessions",
      matchingSessions: "Matching sessions",
      filtersActive: "Filters active",
    },
    session: {
      title: "New treatment session",
      selectPatient: "Select patient",
      voiceTab: "Voice",
      textTab: "Text",
      recordStart: "Start recording",
      recordStop: "Stop recording",
      recording: "Recording...",
      transcribing: "Transcribing...",
      generating: "Generating SOAP report...",
      placeholderText: "Enter your treatment notes here. The AI will turn them into a structured SOAP report.",
      generate: "Generate SOAP report",
      save: "Save session",
      saving: "Saving...",
      pdf: "Export as PDF",
      sectionS: "S — Subjective",
      sectionO: "O — Objective",
      sectionA: "A — Assessment",
      sectionP: "P — Plan",
      regenerate: "Regenerate",
      noPatient: "Please select a patient first.",
      noNotes: "Please enter some notes first.",
      sessionsList: "Sessions",
      backToSession: "Back",
      edit: "Edit",
      saveChanges: "Save changes",
      cancelEdit: "Discard",
      saved: "Saved",
      billing: "Billing",
      billingTitle: "Billable services",
      billingDesc: "Positions per German Heilmittelkatalog. Editable, deletable and manually extendable.",
      billingAdd: "Add position",
      billingAISuggest: "Generate suggestions",
      billingAIRegen: "Re-suggest",
      billingLoading: "Analysing SOAP report...",
      billingEmpty: "No positions yet. Generate suggestions or add manually.",
      billingDisclaimer: "Note: Verify positions against the medical prescription before invoicing.",
      billingColCode: "Code",
      billingColName: "Name",
      billingColRationale: "Description",
      billingSave: "Save",
      copyCode: "Copy",
      copied: "Copied!",
    },
    settings: {
      title: "Settings",
      account: "Account",
      language: "Language",
      privacy: "Privacy",
      privacyDesc: "PhysioSOAP stores your data GDPR-compliant in EU data centers. Patient data is never used to train AI models. You can export or delete your data at any time.",
      retention: "Data retention",
      retentionDesc: "Patient data and sessions are retained for as long as your jurisdiction requires (typ. 10 years for medical records).",
      delete: "Delete account data",
      logout: "Log out",
      practice: "Practice details",
      practiceDesc: "These details appear in the footer of every generated PDF report.",
      practiceName: "Practice name",
      practiceAddress: "Address",
      practicePhone: "Phone",
      practiceEmail: "Email",
      practiceSave: "Save practice details",
      practiceSaved: "Saved!",
      practiceNamePh: "e.g. Physiotherapy Clinic Dr. Smith",
      practiceAddressPh: "123 Main St, London SW1 1AA",
      practicePhonePh: "+44 20 1234 5678",
      practiceEmailPh: "practice@example.com",
    },
    common: {
      loading: "Loading...",
      error: "Error",
      yes: "Yes",
      no: "No",
    },
  },
};
